import { UserPermission } from '@/models/enums/permissions'
import { IUserDTO } from '@/models/user'

import { hasVeePermission, isVeePermission } from './VeePermissions'

function parseStoredUser(): IUserDTO | null {
  try {
    const storedUser = localStorage.getItem('user')
    if (!storedUser) return null

    const userData = JSON.parse(storedUser)
    return new IUserDTO(
      userData.description,
      userData.name,
      userData.email,
      '',
      userData.clientType,
      userData.userRole,
      userData.blocked,
      new Date(userData.updatedAt),
      userData.receiveEmails,
      userData.userType,
    )
  } catch {
    return null
  }
}

export const hasPermission = (permission: UserPermission) => {
  if (isVeePermission(permission)) {
    return hasVeePermission(permission)
  }

  return parseStoredUser()?.permissions.includes(permission) ?? false
}
